/** Shared materials. One instance per look — every mesh reuses these. */

import { MeshStandardMaterial } from "three";

export const HAKI_BLUE = 0x0a4da3;
export const SAFETY_ORANGE = 0xf57f29;
export const WARN_RED = 0xb03a1e;

export type MaterialSet = Readonly<Record<string, MeshStandardMaterial>>;

export const M = {
  alu: new MeshStandardMaterial({ color: 0xd6d9dc, metalness: 0.85, roughness: 0.32, envMapIntensity: 1.1 }),
  aluD: new MeshStandardMaterial({ color: 0xa7adb3, metalness: 0.8, roughness: 0.45, envMapIntensity: 0.9 }),
  cast: new MeshStandardMaterial({ color: 0x8f959b, metalness: 0.6, roughness: 0.6 }),
  steel: new MeshStandardMaterial({ color: 0x5d6870, metalness: 0.8, roughness: 0.4 }),
  thread: new MeshStandardMaterial({ color: 0x2fa06a, metalness: 0.55, roughness: 0.5 }),
  warn: new MeshStandardMaterial({ color: SAFETY_ORANGE, metalness: 0.3, roughness: 0.6 }),
  grip: new MeshStandardMaterial({ color: 0x4f545a, metalness: 0.45, roughness: 0.9 }),
  deckOff: new MeshStandardMaterial({
    color: 0xd6d9dc,
    metalness: 0.6,
    roughness: 0.4,
    transparent: true,
    opacity: 0.14,
  }),
  hatchLid: new MeshStandardMaterial({ color: HAKI_BLUE, metalness: 0.4, roughness: 0.55 }),
  ground: new MeshStandardMaterial({ color: 0x9aa08f, roughness: 1 }),
  rock: new MeshStandardMaterial({ color: 0x84878b, roughness: 0.95 }),
  wood: new MeshStandardMaterial({ color: 0x8a6b4a, roughness: 0.9 }),
  ghost: new MeshStandardMaterial({
    color: HAKI_BLUE,
    transparent: true,
    opacity: 0.35,
    depthWrite: false,
  }),
  ghostBad: new MeshStandardMaterial({
    color: WARN_RED,
    transparent: true,
    opacity: 0.4,
    depthWrite: false,
  }),
  node: new MeshStandardMaterial({
    color: HAKI_BLUE,
    transparent: true,
    opacity: 0.28,
    depthWrite: false,
  }),
  nodeHot: new MeshStandardMaterial({
    color: HAKI_BLUE,
    emissive: HAKI_BLUE,
    emissiveIntensity: 0.7,
  }),
  sel: new MeshStandardMaterial({
    color: HAKI_BLUE,
    emissive: HAKI_BLUE,
    emissiveIntensity: 0.55,
    metalness: 0.5,
    roughness: 0.4,
  }),
  freeEnd: new MeshStandardMaterial({
    color: SAFETY_ORANGE,
    emissive: SAFETY_ORANGE,
    emissiveIntensity: 0.5,
  }),
  hot: new MeshStandardMaterial({
    color: WARN_RED,
    emissive: WARN_RED,
    emissiveIntensity: 0.55,
    metalness: 0.3,
    roughness: 0.5,
  }),
} satisfies MaterialSet;

export type MaterialName = keyof typeof M;
